function MadeWithCare() {
  return (
    <div className="commitment__made-container column border-top">
      <div className="commitment_made-headtitle">
        <h1>천연의 건강 보조제에 대한 우리의 약속</h1>
      </div>
      <div className="commitment__made-background">
      </div>
      <div className="commitment__made-content column">
        <div className="commitment__made-title">
          <h1>정성들여 만듭니다</h1>
        </div>
        <div className="commitment__made-wrapper background__gradient">
          <div className="commitment__made-text column">
            <p>저희는 육지와 바다 모두에 특별한 관계를 가지고 있습니다. 보살핌과 존중, 그리고 자연이 번성할 수록 우리도 번성한다는 근본적인 이해를 기반으로 하고 있습니다. </p>
            <p>뉴질랜드의 넓은 해안선과 청량한 물이 어우러진 결과는 매우 훌륭합니다. 그것은 바로 믿을 수 있는 나라와 사람으로부터 생산된 세계 최고 수준의 영양가 높은 재료입니다.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MadeWithCare;